import React, { useEffect, useRef, useState } from "react";

const FullWidthDiv = ({
	onClick,
	children,
	height = "auto",
	className = "bg-primary text-white",
	disabled = false,
	fontSize = "1rem",
	style = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		fontWeight: "bold",
		backgroundColor: "#426a24",
		color: "#FFF",
	},
}) => {
	const divRef = useRef(null);
	const [dynamicFontSize, setDynamicFontSize] = useState(fontSize);

	useEffect(() => {
		if (fontSize === "auto" && divRef.current) {
			const calculateFontSize = () => {
				if (!divRef.current) return "1rem";

				const divHeight = divRef.current.clientHeight;
				const contentLength = children?.toString().length || 1;

				const baseFontSize = divHeight * 0.75;
				const adjustedSize = Math.min(baseFontSize, (divHeight / contentLength) * 2.5);

				const maxSize = 120;
				return `${Math.min(adjustedSize, maxSize)}px`;
			};

			setDynamicFontSize(calculateFontSize());

			const resizeObserver = new ResizeObserver(() => {
				if (divRef.current) {
					setDynamicFontSize(calculateFontSize());
				}
			});

			try {
				resizeObserver.observe(divRef.current);
			} catch (error) {
				console.error("ResizeObserver hiba:", error);
			}

			return () => {
				try {
					resizeObserver.disconnect();
				} catch (error) {
					console.error("ResizeObserver disconnect hiba:", error);
				}
			};
		}
	}, [fontSize, children]);

	const handleClick = (e) => {
		if (!disabled && onClick) {
			onClick(e);
		}
	};

	return (
		<div
			ref={divRef}
			className={`d-flex align-items-center justify-content-center w-100 rounded ${className}`}
			onClick={handleClick}
			style={{
				height,
				fontSize: fontSize === "auto" ? dynamicFontSize : fontSize,
				cursor: disabled ? "not-allowed" : onClick ? "pointer" : "default",
				opacity: disabled ? 0.65 : 1,
				padding: "0.5rem 1rem",
				...style,
			}}
			role={onClick ? "button" : undefined}
			aria-disabled={disabled}
		>
			{children}
		</div>
	);
};

export default FullWidthDiv;
